import { AuthProvider } from './../auth/auth';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ENV } from '../../environments/environment';
declare let SensorTracker: any; // included in body of html

/*
  Generated class for the SocketProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SocketProvider {
  client: any;
  clientSubject: BehaviorSubject<any>;
  authToken: string;
  constructor(private authService: AuthProvider) {} // private utils: UtilsService

  public getClient() {
    const self = this;

    const refresh = !(
      this.authToken ===
      this.authService.userData.jwtData.jwtResponse.access_token
    );

    if (!this.client || refresh) {
      // const authorizer = new SensorTracker.IFrameAuthorizer(
      //   {
      //     oauthAuthorizeUrl: ENV.oauthAuthorizeUrl,
      //     clientId: 'sensordesk-browser-app'
      //   },
      //   this.authService.fragment
      // );
      // authorizer.start();
      this.authToken = this.authService.userData.jwtData.jwtResponse.access_token;
      this.client = SensorTracker.createClient({
        url: this.http2ws(ENV.websocketServerUrl) + 'ws',
        authorization: this.authToken
      });

      this.client
        .start()
        .then(function(e) {
          self.client.deviceShadow.getDeviceCollection().getView({});
        })
        .then(function(e) {
          self.client.deviceShadow.getShadowCollection().getView({});
        })
        .then(function(e) {
          self.client.credentialsAuthority
            .getAccountCollection()
            .getView({});
        })
        .then(function(e) {
          self.client.deviceShadow.getDeviceCollection();
          self.clientSubject.next(self.client);
          return self.client;
        });
    }
    if (this.clientSubject) {
      return this.clientSubject;
    } else {
      this.clientSubject = new BehaviorSubject(null);
    }
    return this.clientSubject;
  }

  http2ws(url: string): string {
    return url.replace(/^http(s?):/, 'ws$1:');
  }

  public bindCollection(collection, filter) {
    return Observable.create(observer => {
      collection.open();
      const view = collection.getView(filter);
      function digestor() {
        observer.next(view);
      }
      view.on('updated', digestor);
      view.on('error', e => {
        console.log('on error => ', e);
      });
      return function() {
        try {
          view.removeListener('Updated', digestor);
          view.close();
        } catch (e) {
          console.log(e);
        }
      };
    });
  }

  updateDevice(snn: string, data: any) {
    return new Promise((resolve, reject) => {
      this.client.deviceShadow
        .updateDesiredDeviceShadow({
          snn: snn,
          desiredState: data
        })
        .then(result => {
          resolve(result);
        })
        .catch(e => {
          reject();
        });
    });
  }
  updateCommandDevice(params: {snn: string, command: string, params: any}) {
      return Observable.create(observer => {
      this.client.deviceShadow
        .executeDeviceShadowCommand(params)
        .then(result => {
          observer.next(result);
        })
        .catch(e => {
          console.log("Command Error: ",e)
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/socket/socket.ts